@if (effectiveContext(); as centerContext) {
  <article
    class="hd-center-info"
    [class.hd-center-info--full]="isFull()"
    [style.--hd-center-accent]="centerAccent()"
  >
    @if (showingOverview()) {
      <section class="hd-center-info__overview-view">
        <div class="hd-center-info__back-bar">
          <button
            #overviewBackButton
            type="button"
            class="hd-center-info__back-button"
            data-test-id="center-info-overview-back"
            [attr.aria-label]="backToCenterLabel()"
            (click)="backToCenter()"
          >
            <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
            {{ backToCenterLabel() }}
          </button>
        </div>
        <div
          class="hd-center-info__document-scroll"
          data-test-id="center-info-document-scroll"
        >
          <markdown
            class="hd-center-info__markdown"
            [src]="overviewUrl()"
            (load)="onMarkdownRendered()"
          />
        </div>
      </section>
    } @else {
      <header class="hd-center-info__summary">
        <hd-center-mini-card
          [center]="centerContext.center"
          [variant]="variant()"
          [isOpen]="isOpen()"
          [activations]="centerContext.activations"
          [colorBlocks]="colorBlocks()"
        />

        <span
          class="hd-center-info__status"
          data-test-id="center-info-status"
          [class.hd-center-info__status--defined]="isDefined()"
          [class.hd-center-info__status--open]="isOpen()"
        >{{ currentStateLabel() }}</span>
      </header>

      @if (isFull()) {
        <div
          class="hd-center-info__document-scroll"
          data-test-id="center-info-document-scroll"
        >
          <div class="hd-center-info__links-row">
            <div class="hd-center-info__overview-row">
              <span class="hd-center-info__overview-label">{{ overviewLinkLabel() }}</span>
              <button
                #overviewLinkButton
                type="button"
                class="hd-center-info__open-doc"
                data-test-id="center-info-overview-link"
                [title]="overviewLinkLabel()"
                [attr.aria-label]="overviewLinkLabel()"
                (click)="openOverview()"
              >
                <i class="fas fa-circle-info" aria-hidden="true"></i>
              </button>
            </div>

            @if (fearsCenter()) {
              <!-- Enkel voor de drie bewustzijnscentra: duidelijke doorklik
                   naar het angsten-paneel (stijl: locks & keys-doorklikknop). -->
              <button
                type="button"
                class="hd-center-info__panel-link"
                data-test-id="center-info-fears-link"
                [attr.aria-label]="fearsLinkLabel()"
                (click)="openFears($event)"
              >
                <i class="fa-regular fa-face-fearful" aria-hidden="true"></i>
                <span>{{ fearsLinkLabel() }}</span>
                <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
              </button>
            }

            @if (voicesAvailable()) {
              <!-- Enkel voor het keelcentrum: doorklik naar het voices-paneel. -->
              <button
                type="button"
                class="hd-center-info__panel-link"
                data-test-id="center-info-voices-link"
                [attr.aria-label]="voicesLinkLabel()"
                (click)="openVoices($event)"
              >
                <i class="fa-regular fa-lips" aria-hidden="true"></i>
                <span>{{ voicesLinkLabel() }}</span>
                <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
              </button>
            }
          </div>

          <div class="hd-center-info__documents" data-test-id="center-info-docs">
            <details class="hd-center-info__document" open>
              <summary>
                <h2 class="hd-center-info__section-title">
                  <span class="hd-center-info__section-title-text">
                    {{ sectionTitle(generalUrl(), generalLabel()) }}
                  </span>
                  <span class="hd-center-info__section-actions">
                    <i
                      class="fa-solid fa-chevron-down hd-center-info__section-chevron"
                      aria-hidden="true"
                    ></i>
                  </span>
                </h2>
              </summary>
              <markdown
                class="hd-center-info__markdown"
                [class.hd-center-info__markdown--voice-table]="centerContext.center === 'keel'"
                [src]="generalUrl()"
                (load)="onSectionMarkdownLoaded(generalUrl(), $event)"
              />
            </details>

            <details class="hd-center-info__document hd-center-info__document--current" open>
              <summary>
                <h2 class="hd-center-info__section-title">
                  <span class="hd-center-info__section-title-text">
                    {{ sectionTitle(currentStateUrl(), currentStateLabel()) }}
                  </span>
                  <span class="hd-center-info__section-actions">
                    <span class="hd-center-info__current-badge">{{ currentBadgeLabel() }}</span>
                    <i
                      class="fa-solid fa-chevron-down hd-center-info__section-chevron"
                      aria-hidden="true"
                    ></i>
                  </span>
                </h2>
              </summary>
              <markdown
                class="hd-center-info__markdown hd-center-info__markdown--expression-table"
                [src]="currentStateUrl()"
                (load)="onSectionMarkdownLoaded(currentStateUrl(), $event)"
              />
            </details>

            @if (centerContext.showBothStateSections !== false) {
            <details class="hd-center-info__document">
              <summary>
                <h2 class="hd-center-info__section-title">
                  <span class="hd-center-info__section-title-text">
                    {{ sectionTitle(alternateStateUrl(), alternateStateLabel()) }}
                  </span>
                  <span class="hd-center-info__section-actions">
                    <i
                      class="fa-solid fa-chevron-down hd-center-info__section-chevron"
                      aria-hidden="true"
                    ></i>
                  </span>
                </h2>
              </summary>
              <markdown
                class="hd-center-info__markdown hd-center-info__markdown--expression-table"
                [src]="alternateStateUrl()"
                (load)="onSectionMarkdownLoaded(alternateStateUrl(), $event)"
              />
            </details>
            }

            @if (emotionalWavesAvailable()) {
              <!-- Enkel voor de Solar Plexus: overzicht van de drie emotionele
                   golven, met de golven van deze chart gemarkeerd. -->
              <details
                class="hd-center-info__document hd-center-info__document--emotional-waves"
                data-test-id="center-info-emotional-waves"
              >
                <summary>
                  <h2 class="hd-center-info__section-title">
                    <span class="hd-center-info__section-title-text">{{ emotionalWavesLabel() }}</span>
                    <span class="hd-center-info__section-actions">
                      <i
                        class="fa-solid fa-chevron-down hd-center-info__section-chevron"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </h2>
                </summary>
                <hd-emotional-waves-list
                  class="hd-center-info__emotional-waves"
                  [definedChannelKeys]="centerContext.definedChannelKeys"
                />
              </details>
            }

            <details
              class="hd-center-info__document hd-center-info__document--cartography"
              data-test-id="center-info-cartography"
            >
              <summary>
                <h2 class="hd-center-info__section-title">
                  <span class="hd-center-info__section-title-text">
                    {{ sectionTitle(cartographyUrl(), cartographyLabel()) }}
                  </span>
                  <span class="hd-center-info__section-actions">
                    <i
                      class="fa-solid fa-chevron-down hd-center-info__section-chevron"
                      aria-hidden="true"
                    ></i>
                  </span>
                </h2>
              </summary>
              <markdown
                class="hd-center-info__markdown"
                [src]="cartographyUrl()"
                (load)="onSectionMarkdownLoaded(cartographyUrl(), $event)"
              />
            </details>
          </div>
        </div>
      }
    }
  </article>
}
